export default "__VITE_ASSET__f3c80bf7__$_?nuxt_component=async__"